<div class="menu__wrapper">
  <a
    class="menu__item"
    routerLink="list"
    routerLinkActive="menu__item_active"
    [queryParams]="{ id: null, sort: null }"
    queryParamsHandling="merge"
    >Table</a
  >
  @if (!isAllProject()) {
    <a
      class="menu__item"
      routerLink="board"
      routerLinkActive="menu__item_active"
      [queryParams]="{ id: null, sort: null }"
      queryParamsHandling="merge"
      >Board</a
    >
  }
  <span
    class="menu__active"
    [ngStyle]="{ 'left.px': headerActiveLineLeft(), 'width.px': headerActiveLineWidth() }"
  ></span>
</div>
